module.exports = __webpack_public_path__ + "static/media/5.f6d70bd4.svg";